import React from 'react';
import PropTypes from 'prop-types';

function ChevronLeft({ size = 20, color, style = null }) {
  return (
    <svg width={size} height={size} style={style} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className={`icon-chevron-left`} d="M14 16L8 10L14 4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

ChevronLeft.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.number
}

export default ChevronLeft;
